import { Flex, Image, Spinner } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { ROUTE_NAMES } from "@root/constants";
import { NavControl } from "@root/components/dashboard/sidebar/navControl";
import { useLocation } from "react-router-dom";
import useSidebar from "@root/hooks/useSidebar";
import { CustomPopup } from "@root/components/common/modals/CustomPopup";
import { LogoutPopupContent } from "@root/pages/components";
import { useOrganizationBranding } from "@root/context/organization-branding-context";
import HamburgerButton from "@root/components/common/HamburgerButton";

interface MobileHeaderProps {
  onMenuClick?: () => void;
  showHamburger?: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  onMenuClick,
  showHamburger = false,
}) => {
  const { logoUrl, defaultLogoUrl, loading } = useOrganizationBranding();
  const {
    isDarkTheme,
    pathname,
    menuItemsList,
    profileData,
    logoutPopup,
    setLogoutPopup,
    logoutHandler,
    t,
    isMenuOpen,
    setIsMenuOpen,
  } = useSidebar();
  const location = useLocation();
  const path = location.pathname;
  const isDashboard = path === ROUTE_NAMES.PLEDGE_DASHBOARD;
  console.log(isDashboard);

  const isLoggedInUser: any = useSelector(getLoggedInUser);
  console.log(isLoggedInUser?.avatar);
  console.log("isLoggedInUser", isLoggedInUser);

  return (
    <Flex
      justify="space-between"
      alignItems="center"
      w="100%"
      height="68px"
      px="24px"
      borderBottom="1px solid"
      borderColor="#CDD6DC"
      bgColor={"#EEEEF9"}
      //bg="#FFFFFF"
    >
      <Flex alignItems="center" gap="12px">
        {/* Hamburger button on the left side */}
        {showHamburger && onMenuClick && (
          <HamburgerButton onClick={onMenuClick} mr="0px" />
        )}
        {loading ? (
          <Spinner size="md" />
        ) : (
          <Image
            src={logoUrl || defaultLogoUrl}
            alt="Logo"
            maxH="38px"
            objectFit="contain"
          />
        )}
      </Flex>
      <Flex alignItems="center">
        <Flex>
          {isLoggedInUser && (
            <NavControl
              pathname={pathname}
              menuItemsList={menuItemsList}
              isDarkTheme={isDarkTheme}
              isOpen={false}
              profileData={profileData}
              isMenuOpen={isMenuOpen}
              setIsMenuOpen={setIsMenuOpen}
            />
          )}
        </Flex>
      </Flex>

      {/* Logout Popup */}
      {logoutPopup && (
        <CustomPopup
          open={logoutPopup}
          onClose={() => setLogoutPopup(false)}
          title={t("preferences.signOutModalTitle")}
          children={
            <LogoutPopupContent
              onSignOut={logoutHandler}
              onCancel={() => setLogoutPopup(false)}
            />
          }
        />
      )}
    </Flex>
  );
};

export default MobileHeader;
